<template>
    <div class="manual-verification-container mt-3 mb-3 mb-sm-0">
        <h1 class="manual-verification-header mb-3">Worker Identity - Manual Verification</h1>
        <div class="divider mb-1"></div>

        <p class="description">
            Please contact a Site Support team member (if you are in the office) or the 
            Enterprise Service Desk by phone at <a href="tel:+14155078888" class="link">+1 415 507 8888</a> 
            or by email (if you are remote), and they will guide you through a manual identity verification process. 
            Additionally, inform your manager about this manual verification, as they will be required to join a Zoom call.
        </p>

    </div>
</template>

<script>
export default {
    name: "ManualVerification"
};
</script>

<style>
.manual-verification-container {
    max-width: 1200px;
    padding: 0px 30px;
    font-family: artifaktElementRegular;
}

.divider {
    height: 1px;
    width: 100%;
    border: 1px solid lightgray;
}

.manual-verification-header {
    font-size: 18px;
    font-weight: 700;
    color: black;
    font-family: artifaktElementBold;
    line-height: 34px;
    margin: 0px;
}

.description {
    color: black;
    margin-top: 30px;
}

.link {
    color: #000000 !important;
    word-break: break-all;
    text-decoration: underline;
}

.list-heading {
    font-size: 16px;
    font-weight: 700;
    color: black;
    font-family: artifaktElementBold;
    line-height: 34px;
    margin: 0px;
}

.list-details li {
    color: black;
}

@media (max-width: 700px) {
    .manual-verification-container {
        padding: 0px 10px;
    }
}
</style>